export const CCRetirementBacklog = [
  {
    title: "Retired S/n",
    dataIndex: "serialNumber",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.serialNumber?.localeCompare(b.serialNumber),
  },
  {
    title: "Customer Name",
    dataIndex: "customerName",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.customerName.localeCompare(b.customerName),
  },
  {
    title: "MSSL",
    dataIndex: "mssl",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.mssl - b.mssl,
  },

  {
    title: "Business Registration No./ Geneco Account No",
    dataIndex: "accountNo",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.accountNo.localeCompare(b.accountNo),
  },
  {
    title: "Contract Number",
    dataIndex: "contractNumber",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.contractNumber.localeCompare(b.contractNumber),
  },
  {
    title: "Product Name",
    dataIndex: "productName",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.productName.localeCompare(b.productName),
  },
  {
    title: "Revenue (S$/kgCO2e)",
    dataIndex: "revenue",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.revenue.localeCompare(b.revenue),
  },
  {
    title: "Retired Date",
    dataIndex: "retiredDate",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.retiredDate) - new Date(b.retiredDate),
  },
  {
    title: "Retirement Period Start",
    dataIndex: "retirementPeriodStart",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.retirementPeriodStart) - new Date(b.retirementPeriodStart),
  },
  {
    title: "Retirement Period End",
    dataIndex: "retirementPeriodEnd",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.retirementPeriodStart) - new Date(b.retirementPeriodStart),
  },
  {
    title: "Quantity (kgCO2e)",
    dataIndex: "quantity",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.quantity - b.quantity,
  },
  {
    title: "Cumulative Quantity(kgCO2e)",
    dataIndex: "cumulativeQuantity",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.cumulativeQuantity - b.cumulativeQuantity,
  },
  {
    title: "Active CC S/N",
    dataIndex: "activeSerialNumber",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.customerName.localeCompare(b.customerName),
  },
  {
    title: "Cost (S$/kgCO2e)",
    dataIndex: "cost",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.cost - b.cost,
  },
];

export const SGRECRetirementCnI = [
  {
    title: "Retired S/n",
    dataIndex: "serialNumber",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.serialNumber?.localeCompare(b.serialNumber),
  },
  {
    title: "Customer Name",
    dataIndex: "customerName",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.customerName.localeCompare(b.customerName),
  },
  {
    title: "MSSL",
    dataIndex: "mssl",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.mssl.localeCompare(b.mssl),
  },

  {
    title: "Business Registration",
    dataIndex: "accountNo",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.accountNo.localeCompare(b.accountNo),
  },
  {
    title: "Contract Number",
    dataIndex: "contractNumber",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.contractNumber.localeCompare(b.contractNumber),
  },
  {
    title: "Product Name",
    dataIndex: "productName",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.productName.localeCompare(b.productName),
  },
  {
    title: "Revenue (S$/kWh)",
    dataIndex: "revenue",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.revenue.localeCompare(b.revenue),
  },
  {
    title: "Retired Date",
    dataIndex: "retiredDate",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.retiredDate) - new Date(b.retiredDate),
  },
  {
    title: "Retirement Period Start",
    dataIndex: "retirementPeriodStart",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.retirementPeriodStart) - new Date(b.retirementPeriodStart),
  },
  {
    title: "Retirement Period End",
    dataIndex: "retirementPeriodEnd",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.retirementPeriodEnd) - new Date(b.retirementPeriodEnd),
  },
  {
    title: "Quantity (kWh)",
    dataIndex: "quantity",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.quantity - b.quantity,
  },
  {
    title: "Cumulative Quantity(kWh)",
    dataIndex: "cumulativeQuantity",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.cumulativeQuantity - b.cumulativeQuantity,
  },
  {
    title: "Active SGREC S/N",
    dataIndex: "activeSerialNumber",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.activeSerialNumber.localeCompare(b.activeSerialNumber),
  },
  {
    title: "Cost (S$/kWh)",
    dataIndex: "cost",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.cost - b.cost,
  },
  {
    title: "Remarks",
    dataIndex: "remarks",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.remarks.localeCompare(b.remarks),
  },
];

export const RECRetirementBacklog = [
  {
    title: "Retired S/n",
    dataIndex: "serialNumber",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.serialNumber?.localeCompare(b.serialNumber),
  },
  {
    title: "Customer Name",
    dataIndex: "customerName",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.customerName.localeCompare(b.customerName),
  },
  {
    title: "MSSL",
    dataIndex: "mssl",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.mssl - b.mssl,
  },

  {
    title: "Business Registration No./ Geneco Account No",
    dataIndex: "accountNo",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.accountNo.localeCompare(b.accountNo),
  },
  {
    title: "Contract Number",
    dataIndex: "contractNumber",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.contractNumber.localeCompare(b.contractNumber),
  },
  {
    title: "Product Name",
    dataIndex: "productName",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.productName.localeCompare(b.productName),
  },
  {
    title: "Revenue (S$/kWh)",
    dataIndex: "revenue",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.revenue.localeCompare(b.revenue),
  },
  {
    title: "Retired Date",
    dataIndex: "retiredDate",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.retiredDate) - new Date(b.retiredDate),
  },
  {
    title: "Retirement Period Start",
    dataIndex: "retirementPeriodStart",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.retirementPeriodStart) - new Date(b.retirementPeriodStart),
  },
  {
    title: "Retirement Period End",
    dataIndex: "retirementPeriodEnd",
    editable: false,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => new Date(a.retirementPeriodStart) - new Date(b.retirementPeriodStart),
  },
  {
    title: "Quantity (kWh)",
    dataIndex: "quantity",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.quantity - b.quantity,
  },
  {
    title: "Cumulative Quantity(kWh)",
    dataIndex: "cumulativeQuantity",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.cumulativeQuantity - b.cumulativeQuantity,
  },
  {
    title: "Active REC S/N",
    dataIndex: "activeSerialNumber",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.customerName.localeCompare(b.customerName),
  },
  {
    title: "Cost (S$/kWh)",
    dataIndex: "cost",
    editable: true,
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: (a, b) => a.cost - b.cost,
  },
];
